import { BaseEntity } from 'src/app/entity/base-entity';

export class ContactDto extends BaseEntity {
  name: string;
  position: string;
  email: string;
  phone: string;
}
